import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export var InteractionManager = /*#__PURE__*/function () {
  function InteractionManager(engine, container) {
    _classCallCheck(this, InteractionManager);

    this.container = container;
    this._engine = engine;
    this._interactors = engine.plugins.getInteractors(this.container, true);
    this._externalInteractors = [];
    this._particleInteractors = [];
  }

  _createClass(InteractionManager, [{
    key: "externalInteract",
    value: function () {
      var _externalInteract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(delta) {
        var _iterator, _step, interactor;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(this._externalInteractors);
                _context.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context.next = 11;
                  break;
                }

                interactor = _step.value;
                _context.t0 = interactor.isEnabled();

                if (!_context.t0) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return interactor.interact(delta);

              case 9:
                _context.next = 3;
                break;

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t1 = _context["catch"](1);

                _iterator.e(_context.t1);

              case 16:
                _context.prev = 16;

                _iterator.f();

                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 13, 16, 19]]);
      }));

      function externalInteract(_x) {
        return _externalInteract.apply(this, arguments);
      }

      return externalInteract;
    }()
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      var _iterator2 = _createForOfIteratorHelper(this._externalInteractors),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var interactor = _step2.value;
          interactor.handleClickMode && interactor.handleClickMode(mode);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "init",
    value: function init() {
      this._externalInteractors = [];
      this._particleInteractors = [];

      var _iterator3 = _createForOfIteratorHelper(this._interactors),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var interactor = _step3.value;

          switch (interactor.type) {
            case "external":
              this._externalInteractors.push(interactor);

              break;

            case "particles":
              this._particleInteractors.push(interactor);

              break;
          }

          interactor.init();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "particlesInteract",
    value: function () {
      var _particlesInteract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(particle, delta) {
        var _iterator4, _step4, interactor, _iterator5, _step5, _interactor;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iterator4 = _createForOfIteratorHelper(this._externalInteractors);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    interactor = _step4.value;
                    interactor.clear(particle, delta);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                _iterator5 = _createForOfIteratorHelper(this._particleInteractors);
                _context2.prev = 3;

                _iterator5.s();

              case 5:
                if ((_step5 = _iterator5.n()).done) {
                  _context2.next = 13;
                  break;
                }

                _interactor = _step5.value;
                _context2.t0 = _interactor.isEnabled(particle);

                if (!_context2.t0) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return _interactor.interact(particle, delta);

              case 11:
                _context2.next = 5;
                break;

              case 13:
                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t1 = _context2["catch"](3);

                _iterator5.e(_context2.t1);

              case 18:
                _context2.prev = 18;

                _iterator5.f();

                return _context2.finish(18);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 15, 18, 21]]);
      }));

      function particlesInteract(_x2, _x3) {
        return _particlesInteract.apply(this, arguments);
      }

      return particlesInteract;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(particle) {
        var _iterator6, _step6, interactor, _iterator7, _step7, _interactor2;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iterator6 = _createForOfIteratorHelper(this._externalInteractors);

                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    interactor = _step6.value;
                    interactor.isEnabled() && interactor.reset(particle);
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }

                _iterator7 = _createForOfIteratorHelper(this._particleInteractors);

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    _interactor2 = _step7.value;
                    _interactor2.isEnabled(particle) && _interactor2.reset(particle);
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reset(_x4) {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }]);

  return InteractionManager;
}();